import React from "react";

import { Typography, Grid } from "@mui/material";

import { GlassMorphicContainer } from "../styles";

import ContactForm from "./ContactForm";
import Contacts from "./Contacts";
import { Box1400 } from "../styles";

const ContactUs = () => {
  return (
    <Box1400 mt={10}>
      <GlassMorphicContainer>
        <Typography variant="h2neon" mb={3}>
          Contact Us
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Contacts />
          </Grid>
          <Grid item xs={12} sm={6}>
            <ContactForm />
          </Grid>
        </Grid>
      </GlassMorphicContainer>
    </Box1400>
  );
};

export default ContactUs;
